import { SettingActive } from "@ecp-redux/dto/themeSettings/themeSettings.types";
import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IInvestmentsDropdownMessagesScheme = z.object({
  company_purchases: themeScheme
    .MessageScheme
    .default("Zakupy na firmę"),
  add_investment: themeScheme
    .MessageScheme
    .default("Dodaj inwestycję"),
  current_sale: themeScheme
    .MessageScheme
    .default("Sprzedaż bieżąca"),
  see_all_investments: themeScheme
    .MessageScheme
    .default("Zobacz wszystkie inwestycje"),
  no_investment_selected: themeScheme
    .MessageScheme
    .default("Brak wybranej inwestycji"),
  sign_in_to_add_investment: themeScheme
    .MessageScheme
    .default(
      "Zaloguj się lub zarejestruj, aby dodać inwestycję i otrzymać indywidualne cenniki oraz propozycje produktowe."
    ),
});

export const IInvestmentsDropdownSettingsScheme = z.object({
  isSignedIn: z
    .nativeEnum(SettingActive)
    .default(SettingActive.OFF)
    .catch(SettingActive.OFF),
  login_redirect_url: themeScheme.UrlScheme.default("/login").catch("/login"),
  see_all_investments_button_style: themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  investments_list_popup_id: themeScheme.RowPopupScheme.default(""),
  add_investment_popup_id: themeScheme.RowPopupScheme.default(""),
});
